<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5><i class="fa fa-fw fa-cogs mr-2" />Engine</h5>
            <hr />
            <div class="search-wrapper d-flex align-items-center justify-content-between">
                <b-form-group
                    label="Filter"
                    label-for="filterInput"
                    class="form-inline form-group-wrapper mb-3"
                >
                    <div class="d-flex search-input-wrapper">
                        <b-form-input class="ml-2 mr-2"
                            v-model="filter.sn"
                            type="search"
                            id="filterInput"
                            placeholder="SN"
                            @keyup.enter="getItems"
                        />
                        <b-form-select v-model="filter.status" :options="optStatus" class="mr-2">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>Status</b-form-select-option>
                                <b-form-select-option value=-1>Semua</b-form-select-option>
                            </template>
                        </b-form-select>
                        <multiselect v-model="filter.tipe"
                            class="mr-2"
                            :options="optTipe"
                            :allow-empty="true"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            label="name"
                            track-by="id"
                            placeholder="Tipe Engine"
                        />
                        <b-button variant="primary" @click="getItems">
                            <i class="fa fa-search" />
                        </b-button>
                    </div>
                </b-form-group>
                <b-button class="mb-3" variant="primary" @click="$bvModal.show('modal-input')">Input Engine Baru</b-button>
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="items"
                :fields="fields"
                responsive class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada engine.
                </template>
                <template v-slot:cell(sn)="row">
                    {{ row.item.sn }}
                    <div class="small text-muted">{{ row.item.deskripsi }}</div>
                </template>
                <template v-slot:cell(type)="row">
                    {{ row.item.type.name }}
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge :variant="parseBadgeVariantTipe(row.item.status.id)">
                        {{ row.item.status.name }}
                    </b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <b-button size="sm" variant="primary" v-b-tooltip.hover.top title="Edit" @click="openEditModal(row.item)">
                        <i class="fa fa-fw fa-pencil" />
                    </b-button>
                </template>
            </b-table>
            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" />
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :totalRows="totalRows"
                    :per-page="perPage"
                    @change="onPageChange"
                />
            </div>
        </b-card>
        <b-modal id="modal-input" title="Input Engine Baru"
            centered no-close-on-backdrop hide-footer
            @shown="$refs.inputSN.focus()"
        >
            <b-form-group label="SN">
                <b-form-input ref="inputSN" v-model="input.sn"/>
            </b-form-group>
            <b-form-group label="Deskripsi">
                <b-form-input v-model="input.deskripsi" />
            </b-form-group>
            <b-form-group label="Tipe Engine">
                <multiselect
                    v-model="input.tipe"
                    :options="optTipe"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    label="name"
                    track-by="id"
                    placeholder="Pilih Tipe Engine"
                />
            </b-form-group>
            <div class="text-right">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executeInput">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="modal-edit" title="Edit Engine"
            centered no-close-on-backdrop hide-footer
            @shown="$refs.editSN.focus()"
        >
            <b-form-group label="SN">
                <b-form-input ref="editSN" v-model="edit.sn" />
            </b-form-group>
            <b-form-group label="Deskripsi">
                <b-form-input v-model="edit.deskripsi" />
            </b-form-group>
            <b-form-group label="Tipe Engine">
                <multiselect
                    v-model="edit.tipe"
                    :options="optTipe"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    label="name"
                    track-by="id"
                    placeholder="Pilih Tipe Engine"
                />
            </b-form-group>
            <div class="text-right">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executeEdit">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-btn>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'lokasi',
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            input: {
                sn: "",
                deskripsi: "",
                tipe: null
            },

            edit: {
                sn: "",
                deskripsi: "",
                tipe: null
            },

            filter: {
                sn: "",
                tipe: null,
                status: -1
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "sn", label: "SN" },
                { key: "status", label: "Status" },
                { key: "type", label: "Tipe Engine" },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            activeItem: null,

            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,

            optTipe: [],
            optStatus: [
                { value: 0, text: "Ready Line" },
                { value: 1, text: "Installed" },
                { value: 2, text: "Repair" },
                { value: 3, text: "Shipment" },
                { value: 4, text: "Retur" },
                { value: 99, text: "Lainnya" }
            ]

        }
    },

    methods: {

        init() {

            this.initStatus = 0
            let getItems = this.getItems()

            let getTipeOpt = this.$axios.get("engine-type/selection").then(res => {
                this.optTipe = res.data
            })

            Promise.all([getItems, getTipeOpt]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },

        getItems(page = 1) {

            let query = ""

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage - 1, this.perPage)
            param += "&mode=-1"

            if(!this.$helper.isBlank(this.filter.sn)) {
                param += "&filterSn=" + this.filter.sn
            }

            if(this.filter.status != -1) {
                param += "&filterStatus=" + this.filter.status
            }

            if(!this.$helper.isBlank(this.filter.tipe)) {
                param += "&filterType=" + this.filter.tipe.id
            }

            // Execute
            return this.$axios.get("engine/" + param).then(res => {

                this.items = res.data.data
                this.totalRows = res.data.total

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        executeInput() {

            if(this.$helper.isBlank(this.input.sn)) {
                return this.$helper.toastError(this, "Nama tidak boleh kosong!")
            }

            if(this.$helper.isBlank(this.input.deskripsi)) {
                return this.$helper.toastError(this, "Deskripsi tidak boleh kosong!")
            }

            if(this.$helper.isBlank(this.input.tipe)) {
                return this.$helper.toastError(this, "Tipe tidak boleh kosong!")
            }

            let payload = new FormData()
            payload.append("sn", this.input.sn)
            payload.append("deskripsi", this.input.deskripsi)
            payload.append("type", this.input.tipe.id)

            this.isSubmitting = true
            this.$axios.post("engine/", payload).then(res => {

                this.totalRows++

                this.$bvModal.hide("modal-input")
                this.$helper.toastSuccess(this, "Engine baru berhasil ditambahkan!")
                this.input.sn = ""
                this.getItems()

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        executeEdit() {

            if(this.$helper.isBlank(this.edit.sn)) {
                return this.$helper.toastError(this, "SN tidak boleh kosong!")
            }

            if(this.$helper.isBlank(this.edit.deskripsi)) {
                return this.$helper.toastError(this, "Deskripsi tidak boleh kosong!")
            }

            if(this.$helper.isBlank(this.edit.tipe)) {
                return this.$helper.toastError(this, "Tipe tidak boleh kosong!")
            }

            let payload = new FormData()
            payload.append("id", this.activeItem.id)
            payload.append("sn", this.edit.sn)
            payload.append("deskripsi", this.edit.deskripsi)
            payload.append("type", this.edit.tipe.id)

            this.isSubmitting = true
            this.$axios.post("engine/", payload).then(res => {

                this.$bvModal.hide("modal-edit")
                this.$helper.toastSuccess(this, "Engine berhasil diubah!")
                this.getItems()

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        openEditModal(item) {

            this.activeItem = item
            this.edit.sn = item.sn
            this.edit.deskripsi = item.deskripsi
            this.edit.tipe = item.type
            this.$bvModal.show("modal-edit")

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems()
        },

        onPageChange(newPage) {
            this.getItems(newPage)
        },

        parseBadgeVariantTipe(id) {
            switch(id) {
                case 0: return "dark"
                case 1: return "success"
                case 2: return "danger"
                case 3: return "primary"
                case 4: return "warning"
                default: return "light"
            }
        }

    },

    created(){
        this.init()
    }

}
</script>
